import React, { useState, useEffect } from 'react';
import Game from '../../../../class/Game/Game';
import Games from '../../../../class/Game_copy/Game';
import ProviderGames from './ProviderGames';



import LOAD_GAMES_BY_PROVIDER_ID from '../../modal/load_games_by_provider_id';

const cmsUrl = process.env.REACT_APP_CMS_URL_ASSETS;

const ProviderListCasino = ({ AuthService,category, isLogged, setIsLoginModalOpen }) => {
  const [providers, setProviders] = useState([]); // Список провайдерів
  const [loadedProviders, setLoadedProviders] = useState([]); // Завантажені провайдери
  const [loading, setLoading] = useState(true);
  const user_id = AuthService.getCustom('user_id');


  const [selectedProvider, setSelectedProvider] = useState(null);
  const [showGamesModalSingleProvider, setshowGamesModalSingleProvider] = useState(false);

  const openSingleProvidersModal = (provider) => {
    setSelectedProvider(provider);
    setshowGamesModalSingleProvider(true);
  };
  
  const closeGamesModal = () => {
    setSelectedProvider(null);
    setshowGamesModalSingleProvider(false);
  };

  const getProviderIcon = (providerslug) => {
    return `${cmsUrl}static-assets/providers/${providerslug}.png`;
};

  useEffect(() => {
    const fetchProviders = async () => {
      try {
        let userId = user_id ?? '';

        const data = await Games.getProviders(userId,category);
        const allProviders = data.params.providers || [];

        setProviders(allProviders);
        setLoading(false);
        for (const provider of allProviders) {
          try {
            await new Promise(resolve => setTimeout(resolve, 200));
            setLoadedProviders(prevState => [...prevState, provider]);
          } catch (error) {
            console.error(`Error loading provider ${provider.id}:`, error);
          }
        }

      } catch (error) {
        console.error('Error fetching providers:', error);
        setLoading(false);
      }
    };

    fetchProviders();
  }, [user_id]);

  const renderLoadingGames = () => {
    return Array.from({ length: 4 }).map((_, index) => (
      <div key={index} className="HomeSectionCasinoGames_game">
        <div className="CasinoGameCard_root">
          <div className="CasinoGamePreview_root blurred">
            <div className="CasinoGamePreview_gradient"></div>
            <img
              className="ResponsivePicture_img CasinoGamePreview_image"
              src="https://storage.googleapis.com/camasy-images/casino/only__play__619cb11478244.png"
              style={{
                filter: 'blur(10px)',
              }}
              alt="Loading..."
            />
          </div>
          <div className="CasinoGameCard_info CasinoGameCard_withProvider">
            <div className="CasinoGameCard_icon_placeholder"></div>
            <p
              className="CasinoGameCard_name_placeholder"
              style={{ filter: 'blur(10px)' }}
            >
              Loading...
            </p>
          </div>
        </div>
      </div>
    ));
  };

  const renderLoadingProviders = () => {
    return Array.from({ length: 2 }).map((_, index) => (
      <div key={index} className="body main-layout-item">
        <div className="Home_root">
          <div className="Home_games">
            <div className="Home_header">
              <a href="#" className="HomeSection_header">
                <img
                  alt="Provider"
                  src="https://via.placeholder.com/50"
                  className="HomeSection_icon"
                />
                <div className="HomeSection_label">Loading...</div>
                <div className="HomeSection_right">
                  <div className="HomeSection_headerLink"></div>
                  <div className="HomeSection_caption">0 Giochi</div>
                </div>
              </a>
            </div>
            <div className="HomeSectionCasinoGames_list">
              {renderLoadingGames()}
            </div>
          </div>
        </div>
      </div>
    ));
  };

  return (
    <div>
    
      {loadedProviders.map(provider => (
        <div
          key={provider.id}
          className="body main-layout-item"
          id={`provider-${provider.id}`}
        >
          <div className="Home_root">
            <div className="Home_games">
              <div className="Home_header">
                <a href="#" className="HomeSection_header">
                  <img
                    alt={provider.name || 'Provider'}
                    src={getProviderIcon(provider.slug)}
                    className="HomeSection_icon"
                  />
                  <div className="HomeSection_label">{provider.name}</div>
                  <div className="HomeSection_right">
                    <div className="HomeSection_headerLink"  onClick={() => openSingleProvidersModal(provider)}>Tutti</div>
                    <div className="HomeSection_caption">
                      {provider.active_games || 0} Giochi
                    </div>
                  </div>
                </a>
              </div>
              <div className="HomeSectionCasinoGames_list">
                <ProviderGames
                  provider={provider}
                  user_id={user_id}
                  cetegory={category}
                  AuthService={AuthService}
                  isLogged={isLogged}
                  setIsLoginModalOpen={setIsLoginModalOpen}
                />
              </div>
            </div>
          </div>
        </div>
      ))}




      {loading || loadedProviders.length < providers.length
        ? renderLoadingProviders()
        : null}

    {showGamesModalSingleProvider && (
                <LOAD_GAMES_BY_PROVIDER_ID
                  Game={Games}
                  AuthService={AuthService}
                  user_id={AuthService.getCustom('user_id') || ''}
                  provider_id={selectedProvider?.id}
                  category_id={selectedProvider?.category_id}
                  provider_name={selectedProvider?.name}
                  provider_slug={selectedProvider?.slug}
                  onClose={closeGamesModal}
                  isLogged={isLogged}
                  setIsLoginModalOpen={setIsLoginModalOpen}
                />
              )}
    </div>



  );
};

export default ProviderListCasino;
